import { IState } from '../../../../../store/types';
import { connect } from 'react-redux';
import { PhraseNotesPreview } from '../components/PhraseNotesPreview';
import { IPhraseNotesPreviewEvents, IPhraseNotesPreviewFields } from '../components/types';
import { PhraseNotesPreviewEvents } from './events';
import { PhraseDetailsSelectors } from '../../../../../store/phrase-details/selectors';

const mapStateToProps = (
	dispatch: any
) => {
	return (
		state: IState
	): IPhraseNotesPreviewFields => {
		const note = PhraseDetailsSelectors.getCurrentNote(state);
		const text = note?.text || '';
		const authorUserName = note?.authorInfo?.userName || '';
		const authorName = note?.authorInfo?.name || '';

		return {
			text,
			authorName,
			authorUserName,
		}
	};
}

const mapDispatchToProps = (
	dispatch: any
): IPhraseNotesPreviewEvents => {
	return {
		onEdit: () => dispatch(PhraseNotesPreviewEvents.onEdit()),
		onClickAuthor: () => dispatch(PhraseNotesPreviewEvents.onClickAuthor()),
	}
}

export const PhraseNotesPreviewHOC = connect(
	mapStateToProps,
	mapDispatchToProps
)(PhraseNotesPreview);

PhraseNotesPreviewHOC.displayName = 'PhraseNotesPreviewHOC';
